export const blockIconsHardwareDesktopWindowsNew = (
	<span className='material-symbols-outlined'>desktop_windows</span>
);
